import { namespaces } from '@common'

export const namespace = namespaces.test.value
export const schema = 'ninjaSchema'
export const backendDocType = 'Ninja'
export const docPrivilege = 'test'
